<div class="container fixed">
	<div class="row">
		<div class="col-md-10 col-md-offset-1 searchbox" [ngClass]="{'disabled': isLoading}">
			<search [(ngModel)]="searchTerm" large="true" (onAction)="search()" placeholder="Search Payables" #payableSearch keyboardAccelerator="9" (onKeyboardAction)="search()" [isLoading]="isLoading"></search>
		</div>
	</div>
	<div class="row filter-row" style="align-items:flex-start">
		<div class="col-sm-5 col-md-7">
			<filter-list *ngIf="filterOptions.length" [itemType]="'payable'" [activeFilters]="filters" [filterOptions]="filterOptions" (filterValue)="filterTheList($event)"></filter-list>
		</div>
		<div class="col-sm-4 col-md-3 border-left-md">
			<div class="form-group mb-0">
				<label>Update Status</label>
				<div class="input-group">
					<select class="form-control" [(ngModel)]="updatedStatus">
						<option value='' selected disabled>-- Select --</option>
						<option *ngFor="let option of statusList" [value]="option.value" #batchStatus>{{option.label}}</option>
					</select>
					<span class="input-group-btn">
						<button type="button" class="btn btn-default" (click)="updateStatus()" [disabled]="!selectedPayables.length || !updatedStatus">Apply</button>
					</span>
				</div>
			</div>
		</div>
		<div class="col-sm-3 col-md-2">
			<div class="list-actions mt-2">
				<div class="list-filters">
					<button type="button" class="btn btn-default" (click)="filterToggle('showClosed')" [ngClass]="{'active btn-primary':showClosed}">
						<i class="glyphicon glyphicon-lock"></i><span *ngIf="showClosed"> Hide</span><span *ngIf="!showClosed"> Show</span> Closed
					</button>
				</div>
			</div>
		</div>
	</div>

	<div class="row">
		<div class="col-md-12 wo-list-column mt-1" id="infinite-scroll-list">
			<table *ngIf="showTotal && payableSet.length && payablesTotal">
				<tr><td style="width:94%"><div class="alert alert-success list-total">Total Payables for selected date: <span>{{payablesTotal | currencyFormat}}</span></div></td><td style="width:6%;"></td></tr>
			</table>
			<table id="wo-list" class="table table-select-list mb-0" cellspacing=0 cellpadding=0>
				<caption class="sr-only">Sort list links</caption>
				<thead>
				<tr>
					<th scope="col" style="width:6.2%">
						<label class="custom-checkbox large" style="position: relative; top: -6px;">
							<input type="checkbox" [ngModel]="selectAll" (change)="toggleSelectAll()">
							<span class="checkmark"></span>
						</label>
					</th>
					<th scope="col" class="invoice-col">
						<infinite-scroll-header class="sortable" label="Invoice Number" field="invoiceNumber" [currentSort]="currentSort" [sortDirection]="sortDirection" (onSort)="sortList($event)"></infinite-scroll-header>
					</th>
					<th scope="col" class="job-col">
						<infinite-scroll-header class="sortable" label="Job / Project Manager" field="jobName" [currentSort]="currentSort" [sortDirection]="sortDirection" (onSort)="sortList($event)"></infinite-scroll-header>
					</th>
					<th scope="col" class="supplier-col">
						<infinite-scroll-header class="sortable" label="Supplier Name" field="supplierName" [currentSort]="currentSort" [sortDirection]="sortDirection" (onSort)="sortList($event)"></infinite-scroll-header>
					</th>
					<th scope="col" class="status-col">
						<infinite-scroll-header class="sortable" label="Status" field="status" [currentSort]="currentSort" [sortDirection]="sortDirection" (onSort)="sortList($event)"></infinite-scroll-header>
					</th>
					<th scope="col" class="rec-col">
						<infinite-scroll-header class="sortable" label="Date Received" field="invoiceDate" [currentSort]="currentSort" [sortDirection]="sortDirection" (onSort)="sortList($event)"></infinite-scroll-header>
					</th>
					<th scope="col" class="posted-col">
						<infinite-scroll-header class="sortable" label="Invoice Date" field="invoiceDueDate" [currentSort]="currentSort"
							[sortDirection]="sortDirection" (onSort)="sortList($event)"></infinite-scroll-header>
					</th>
					<th scope="col" class="date-col">
						<infinite-scroll-header class="sortable" label="Date Posted" field="invoicePostedDate" [currentSort]="currentSort" [sortDirection]="sortDirection" (onSort)="sortList($event)"></infinite-scroll-header>
					</th>
					<th scope="col" class="amount-col" class="text-right">
						<infinite-scroll-header class="sortable" label="Amount" field="amount" [currentSort]="currentSort" [sortDirection]="sortDirection" (onSort)="sortList($event)"></infinite-scroll-header>
					</th>
					<th scope="col" class="list-actions"></th>
				</tr>
				</thead>
			</table>
			<div id="top-of-list-marker"></div>
		</div>
	</div>
</div>
<div class="container list-container">
	<div class="attached infinite-scroll-list"
		infiniteScroll
		[infiniteScrollDistance]="1"
		[infiniteScrollThrottle]="50"
		[scrollWindow]="true"
		(scrolled)="onScroll($event)"
		*ngIf="!isLoading" [@fadeInOut]>
		<table class="table table-select-list" cellspacing=0 cellpadding=0>
			<caption class="sr-only">List of payables</caption>
			<thead class="spacer">
				<tr>
					<th scope="col" class="check-col"></th>
					<th scope="col" class="invoice-col"></th>
					<th scope="col" class="job-col"></th>
					<th scope="col" class="supplier-col"></th>
					<th scope="col" class="status-col"></th>
					<th scope="col" class="rec-col"></th>
					<th scope="col" class="date-col"></th>
					<th scope="col" class="posted-col"></th>
					<th scope="col" class="amount-col"></th>
					<th scope="col" class="list-actions"></th>
				</tr>
			</thead>
			<tbody>
			<tr class="wo-list-item" *ngFor="let i of payableSet">
				<td scope="row">
					<label class="custom-checkbox">
						<input type="checkbox" [(ngModel)]="i.selected" [checked]="i.selected" (change)="updateSelected(i)">
						<span class="checkmark"></span>
					</label>
				</td>
				<td scope="row" (click)="editEntity(i)" class="break-word">
					{{ i.invoiceNumber }}
				</td>
				<td scope="row" (click)="editEntity(i)">
					<div>{{ i.job.name }}</div>
					<div class="pm-name">{{ i.job.projectManager ? i.job.projectManager.firstName + ' ' + i.job.projectManager.lastName : '' }}</div>
				</td>
				<td scope="row" (click)="editEntity(i)">
					<div *ngIf="i.supplier">{{ i.supplier.name }}</div>
				</td>
				<td scope="row" (click)="editEntity(i)">
					<div class="status-options {{i.css}}">{{ i.status || '' }}</div>
				</td>
				<td scope="row" (click)="editEntity(i)">
					{{ i.invoiceDate | dateFormat: 'MM/DD/YYYY' }}
				</td>
				<td scope="row" (click)="editEntity(i)">
					{{ i.invoiceDueDate | dateFormat: 'MM/DD/YYYY' }}
					</td>
					<td scope="row" (click)="editEntity(i)">
					{{ i.invoicePostedDate | dateFormat: 'MM/DD/YYYY' }}
				</td>
				<td scope="row" (click)="editEntity(i)" class="text-right" style="word-break:break-all">
					{{ i.amount | currencyFormat }}
				</td>
				<td scope="row" (click)="editEntity(i)" class="list-actions">
					<button class="btn btn-default" type="button" (click)="editEntity(i)">Edit</button>
				</td>
			</tr>
			</tbody>
		</table>
	</div>
	<div *ngIf="isLoading" id="loading" [@fadeInOut]>Loading...</div>
	<div *ngIf="!isLoading && !payableSet.length" id="loading">No results</div>
</div>
